  $(document).ready(function() {
    $(document).on('click','.quick-add button.card__link',function(e) {
      e.preventDefault();
      var get_id = $(this).data('id');
      console.log('get_id = '+get_id);
      setTimeout(function() {
        // Serialize the form data
    var formData = $('#QuickAdd-' + get_id + ' form').serialize();
      
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            dataType: 'json',
            success: function(cart) {
                // Update the cart count in the UI
              console.log('cart data = '+JSON.stringify(cart));
          $.get("/cart.json",function(result){
             $('.cart-count-bubble span[aria-hidden="true"]').text("("+result['item_count']+")");
});
      
              
       
            },
            error: function(xhr, status, error) {
                console.error(error);
            }
        });
        
        },3000);
      $(this).find('span').text('Added');
        $(this).addClass('added-product');
      $(this).attr('disabled','disabled');
      
    });

//     $(document).on('click', '.process-tab-title .captitles', function() {
//     var get_process = $(this).data('tab');
//     if (get_process == 'pouch') {
//       console.log('pouch');
//         $('.product-row ').each(function() {
//             var pro_name = $(this).find('.product-name');
//             pro_name.hover(
//                 function() {
//                   var get_taste = $(this).data('custom-taste');
//                     $(this).parent().parent().find('.taste-message').addClass('show-msg');
//                 },
//                 function() {
//                     $(this).parent().parent().find('.taste-message').removeClass('show-msg');
//                 }
//             );
//         });
//     } 
//     else {
//       console.log('capsule');
//       $('.product-row ').each(function() {
//             var pro_name = $(this).find('.product-name');
//             pro_name.hover(
//                 function() {
//                   var get_taste = $(this).data('custom-taste');
//                     $(this).parent().parent().find('.taste-message').removeClass('show-msg');
//                 },
//                 function() {
//                     $(this).parent().parent().find('.taste-message').removeClass('show-msg');
//                 }
//             );
//         });
//     }
// });

    
  });